import React, { useEffect, useState } from 'react';

function ProfileModal({ show, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) return;
    setLoading(true);
    setError('');
    fetch('api/General/GetProfile')
      .then(r => r.json())
      .then(d => {
        // normalize and trim string fields
        const clean = (v) => (typeof v === 'string' ? v.trim() : v);
        const normalized = {
          regnum: d.regNum,
          nameEnglish: clean(d.name_en),
          nameArabic: clean(d.name_ar),
          birthdate: clean(d.birth_date),
          nationality: clean(d.nationality_en || d.nationality_ar),
          sponsor: clean(d.geha_efad_en || d.geha_efad_ar),
          identityNo: clean(d.identity_number),
          identityType: clean(d.identity_type),
          faculty: clean(d.faculty_en || d.faculty_ar),
          department: clean(d.dep_en || d.dep_ar),
          study: clean(d.study_en || d.study_ar),
          campus: '',
          status: clean(d.study_status),
          email: clean(d.email),
          mobile: clean(d.tel),
          address: clean(d.address),
          dean: clean(d.dean_ar),
          head: clean(d.head_ar),
          gpa: clean(d.gpa),
          hours: clean(d.hours),
          remaining: clean(d.remaining)
        };
        setData(normalized);
        setLoading(false);
      })
      .catch(e => {
        console.error(e);
        setError('Failed to load profile');
        setLoading(false);
      });
  }, [show]);

  if (!show) return null;

  // Detect UI direction/language
  const isRtl = typeof document !== 'undefined' && document.documentElement && document.documentElement.dir === 'rtl';
  const label = (en, ar) => (isRtl ? ar : en);

  return (
    <div>
      <div className="modal-backdrop fade show" style={{ display: 'block' }} onClick={onClose}></div>
      <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" onClick={onClose}>
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document" onClick={e => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="fa fa-id-card mr-2"></i>
                {label('Profile Details', '?????? ????? ??????')}
              </h5>
              <button type="button" className="close" aria-label="Close" onClick={onClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" dir={isRtl ? 'rtl' : 'ltr'}>
              {loading && (
                <div className="text-center">
                  <i className="fas fa-spinner fa-spin"></i>
                </div>
              )}
              {error && <div className="alert alert-danger">{error}</div>}
              {data && (
                <div className="container-fluid">
                  <div className="row mb-3">
                    <div className="col-md-3 text-center">
                      <img src={`api/General/Image/${data.regnum}`} alt="Student" className="img-thumbnail" />
                    </div>
                    <div className="col-md-9">
                      {/* Personal Info */}
                      <h5 className="mt-0">{label('Personal Info', '???????? ???????')}</h5>
                      <div className="row">
                        <div className="col-md-6"><strong>{label('Name', '?????')}:</strong> {isRtl ? (data.nameArabic || data.nameEnglish) : (data.nameEnglish || data.nameArabic)}</div>
                        <div className="col-md-6"><strong>{label('Regnum', '????? ???????')}:</strong> {data.regnum}</div>
                        <div className="col-md-6"><strong>{label('Nationality', '???????')}:</strong> {data.nationality}</div>
                        <div className="col-md-6"><strong>{label('Birthday', '????? ???????')}:</strong> {data.birthdate}</div>
                        <div className="col-md-6"><strong>{label('Identity No', '??? ??????')}:</strong> {data.identityNo}</div>
                        <div className="col-md-6"><strong>{label('Identity Type', '??? ??????')}:</strong> {data.identityType}</div>
                        <div className="col-md-12"><strong>{label('Address', '???????')}:</strong> {data.address}</div>
                      </div>

                      {/* Educational Info */}
                      <hr />
                      <h5>{label('Educational Info', '???????? ????????')}</h5>
                      <div className="row">
                        <div className="col-md-6"><strong>{label('Faculty', '??????')}:</strong> {data.faculty}</div>
                        <div className="col-md-6"><strong>{label('Department', '?????')}:</strong> {data.department}</div>
                        <div className="col-md-6"><strong>{label('Study', '??????')}:</strong> {data.study}</div>
                        <div className="col-md-6"><strong>{label('Status', '?????? ????????')}:</strong> {data.status}</div>
                        <div className="col-md-6"><strong>{label('Dean', '??????')}:</strong> {data.dean}</div>
                        <div className="col-md-6"><strong>{label('Head', '???? ?????')}:</strong> {data.head}</div>
                        <div className="col-md-6"><strong>{label('GPA', '??????')}:</strong> {data.gpa}</div>
                        <div className="col-md-6"><strong>{label('Hours', '???????')}:</strong> {data.hours}</div>
                        <div className="col-md-6"><strong>{label('Remaining', '???????')}:</strong> {data.remaining}</div>
                        <div className="col-md-6"><strong>{label('Sponsor', '????? ???????')}:</strong> {data.sponsor}</div>
                      </div>

                      {/* Contact Info */}
                      <hr />
                      <h5>{label('Contact Info', '?????? ???????')}</h5>
                      <div className="row">
                        <div className="col-md-6"><strong>{label('Email', '?????? ??????????')}:</strong> {data.email}</div>
                        <div className="col-md-6"><strong>{label('Mobile', '?????? ???????')}:</strong> {data.mobile}</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileModal;



// WEBPACK FOOTER //
// ./src/components/ProfileModal.js